

















































































import {
    Component, Prop, Vue, Watch,
} from 'vue-property-decorator';
import Compressor from 'compressorjs';
import FileUpload from 'vue-upload-component';
import { ImageInfo } from '@luxtag/papybase';
import moment from 'moment';
import { upload } from '@/plugins/papybase/papybaseInit';

const uuidv4 = require('uuid/v4');

@Component({
    components: {
        FileUpload,
    },
})
export default class InsertPhotoDialogUpload extends Vue {
    @Prop() readonly dialogStatus!: boolean;

    public uploadDropZoneId = 'insert_photo_dialog_upload_555';

    public isDropOnUploadZone = false;

    public files = [];

    public uploadCounter = 0;

    public progresses: any = {};

    public uploadButtonHover = false;

    public fileUploadProperties = {
        accept: 'image/png,image/gif,image/jpeg,image/webp',
        extensions: 'gif,jpg,jpeg,png,webp',
        multiple: false,
        maximum: this.$store.getters.getMaxImage,
        minSize: 1024,
        size: 1024 * 1024 * 10,
        autoCompress: 1024 * 1024,
        drop: true,
        postAction: '/upload/post',
        putAction: '/upload/put',
        name: 'product',
    }

    public created() {
        this.preventDrop();
    }

    public inputFilter(newFile: any, oldFile: any, prevent: any) {
        const that = this;
        if (newFile && !oldFile) {
            // Before adding a file
            // Filter picture
            if (!/\.(gif|jpg|jpeg|png|webp)$/i.test(newFile.name)) {
                console.error('Your choice is not a picture');
                return prevent();
            }

            // Filter system files or hide files
            if (/(\/|^)(Thumbs\.db|desktop\.ini|\..+)$/.test(newFile.name)) {
                return prevent();
            }

            // Filter php html js file
            if (/\.(php5?|html?|jsx?)$/i.test(newFile.name)) {
                return prevent();
            }

            const imageId = uuidv4();
            that.$set(that.progresses, imageId, 0);

            // Create the 'blob' field for thumbnail preview
            newFile.blob = '';
            const URL = window.URL || (window as any).webkitURL;
            if (URL && URL.createObjectURL) {
                newFile.blob = URL.createObjectURL(newFile.file);
            }

            const compressor = new Compressor(newFile.file, {
                quality: 1,
                maxWidth: 1440,
                maxHeight: 1440,
                success(result: any) {
                    const file = new File([result], newFile.file.name, {
                        lastModified: newFile.file.lastModified,
                        type: newFile.file.type,
                    });
                    that.handleUploadTask(newFile, file, imageId);
                },
                error(err) {
                    console.error(err.message);
                },
            });
        }
    }

    public inputFile(newFile: any, oldFile: any) {
        if (newFile && !oldFile) {
            // add
            // console.log('add', newFile);
        }
        if (newFile && oldFile) {
            // update
            // console.log('update', newFile);
        }
        if (!newFile && oldFile) {
            // remove
            // console.log('remove', oldFile);
        }
    }

    public handleUploadTask(file: any, compressedFile: any, id: any) {
        const that = this;

        upload.uploadImage(this.jwt, compressedFile, (progressEvent: any) => {
            // proggress
            const proggress = Math.round((progressEvent.loaded * 100) / progressEvent.total);
            that.$set(that.progresses, id, proggress);
        }).then((res) => {
            file.url = res.url;
            // await that.saveProductImageToDB(uniqueName, downloadURL);
            that.uploadCounter += 1;
        }).catch((err) => {
            console.error(err);
        });
    }

    get jwt() {
        return this.$store.getters.getJwt;
    }

    private preventDrop() {
        window.addEventListener('dragenter', (e: any) => {
            this.preventDropCondition(e);
        }, false);

        window.addEventListener('dragover', (e: any) => {
            this.preventDropCondition(e);
        }, false);
        window.addEventListener('drop', (e) => {
            this.preventDropCondition(e);
        }, false);
    }

    private preventDropCondition(e: any) {
        if (e.target.id !== this.uploadDropZoneId) {
            this.isDropOnUploadZone = false;
            e.preventDefault();
            e.dataTransfer.effectAllowed = 'none';
            e.dataTransfer.dropEffect = 'none';
        } else {
            this.isDropOnUploadZone = true;
        }
    }

    @Watch('uploadCounter')
    private onUploadCounterChanged(val: number, oldVal: number) {
        // console.log(val);
        if (val === this.files.length) this.$emit('uploadFinish', this.files);
    }

    @Watch('dialogStatus')
    private onCheckDialogChanged(val: boolean, oldVal: boolean) {
        if (!val) {
            this.uploadCounter = 0;
            this.files = [];
            this.progresses = {};
        }
    }
}
